export class ImageConfigItem {
  purpose_key: string
  width: number

  constructor(purposeKey: string, width: number) {
    this.purpose_key = purposeKey
    this.width = width
  }
}
